/* global Swiper */



(function () {

	"use strict";

	// init desktop hero carousel
	new Swiper(".q-tech-debt", {
		spaceBetween: 100,
		slidesPerView: 2,
		centeredSlides: true,
		loop: true,
		direction: 'vertical',
		navigation: false,
		allowTouchMove: false, // Disable dragging
		speed: 800,
		autoplay: {
			delay: 2500
		},
		effect: 'coverflow',
		coverflowEffect: {
		  rotate: 0,
		  slideShadows: false
		},
		 breakpoints: {
			1280: {
				spaceBetween: 250,
			}
		}
	});

	// init mobile hero carousel
	new Swiper(".q-tech-mobile-debt", {
		spaceBetween: 10,
		slidesPerView: 1.3,
		centeredSlides: true,
		loop: true,
		allowTouchMove: false, // Disable dragging
		navigation: false,
		autoplay:true,
		breakpoints: {
			640: {
				spaceBetween:20,
			}
		}
	});

}());

(function ($, MktoForms2) {

	"use strict";

	MktoForms2.onFormRender(function () {
		setTimeout(function(){
			$(".mktoButtonWrap button[type=submit]").text("Get Your Report");
		}, 5);
	});
}(jQuery, MktoForms2));